import React, { HTMLAttributes } from 'react'

import { Label } from '@hhgtech/hhg-components'
// import {
// Avatar,
// Button,
// Heading
// } from '@hhgtech/hhg-components'
// import { Container } from 'components/atoms/container'
// import { useRouter } from 'next/router'
// import ChevronRightBlue from 'public/images/chevronRightBlue.svg'
// import Repeat from 'public/images/repeat.svg'
// import { useIntl } from 'react-intl'

import { assetImagePath } from 'interfaces/constants'

import {
  StyledInfoContainer,
  StyledIconHeading,
  StyledContainer,
} from './index.styled'

export type ToolsInfoCardProps = {
  icon?: JSX.Element
  headingTitle?: React.ReactNode
  className?: string
  children?: JSX.Element
} & HTMLAttributes<HTMLDivElement>

const ToolsInfoCard = ({
  children,
  icon,
  headingTitle,
  ...rest
}: ToolsInfoCardProps) => {
  // const { formatMessage: f } = useIntl()

  // const { locale } = useRouter()

  return (
    <StyledInfoContainer {...rest}>
      <StyledIconHeading>
        {icon || (
          <img
            loading="lazy"
            style={{
              height: '16px',
              width: '16px',
            }}
            src={`${assetImagePath}/info-icon.svg`}
            alt=""
          />
        )}

        {React.isValidElement(headingTitle) ? (
          headingTitle
        ) : (
          <Label size="label1" htmlFor="">
            {headingTitle}
          </Label>
        )}
      </StyledIconHeading>
      <StyledContainer>{children}</StyledContainer>
    </StyledInfoContainer>
  )
}

export { ToolsInfoCard }
